import { TrendingUp } from "lucide-react";
import { reais, roi } from "./api";

/**
 * Manchete do relatorio: quanto a campanha devolveu sobre o investido.
 *
 * Nos dois canais a manchete e' o cruzamento (backend: sms/cruzamento.py) —
 * pedido de quem recebeu, na janela, mais o que veio pelo link. So' pelo link
 * o SMS mostrava 4 pedidos onde quem recebeu fez 79, e a ligacao nem tem link.
 * No SMS a venda pelo link continua na frase, como detalhe exato.
 */
export default function RetornoCampanha({ financeiro, funil, cz, ehVoz }) {
  const quem = ehVoz ? "quem recebeu a ligação" : "quem recebeu o SMS";
  const peloLink = !ehVoz && funil.pedidos > 0
    ? ` — ${funil.pedidos} ${funil.pedidos === 1 ? "veio" : "vieram"} pelo link (${financeiro.receita_formatada})`
    : "";
  const frase = cz
    ? `Investiu ${financeiro.custo_formatado} e ${quem} pediu ${reais(cz.receita_centavos)} em até ${cz.janela_dias} dias${peloLink}`
    : `Investiu ${financeiro.custo_formatado}`;

  return (
    <div className="rounded-2xl border bg-card p-5 flex flex-wrap items-center justify-between gap-4">
      <div>
        <div className="flex items-center gap-2 text-sm text-muted-foreground mb-1">
          <TrendingUp className="w-4 h-4" /> Retorno da campanha
        </div>
        <p className="text-4xl font-bold tabular-nums">{roi(cz?.roi_centesimos ?? null)}</p>
        <p className="text-sm text-muted-foreground mt-1">{frase}</p>
      </div>
      {cz && (
        <div className="flex gap-6 text-right">
          <div>
            <p className="text-[11px] uppercase tracking-wider text-muted-foreground">Faturamento</p>
            <p className="text-xl font-bold tabular-nums mt-0.5">
              {cz.pedidos.toLocaleString("pt-BR")}
              <span className="text-muted-foreground font-semibold text-base"> {cz.pedidos === 1 ? "pedido" : "pedidos"} / </span>
              {reais(cz.receita_centavos)}
            </p>
          </div>
          <div>
            <p className="text-[11px] uppercase tracking-wider text-muted-foreground">Ticket médio</p>
            <p className="text-xl font-bold tabular-nums mt-0.5">
              {cz.pedidos ? reais(Math.trunc(cz.receita_centavos / cz.pedidos)) : "—"}
            </p>
          </div>
        </div>
      )}
    </div>
  );
}
